// Si las hojas se animan al cerrarse: no con "reducir movimiento" en el sistema ni en los tests
// (test/setup.ts las apaga para que cerrar sea inmediato; los tests de la animación las encienden).
let enabled = true

export const setAnimations = (on: boolean): void => {
	enabled = on
}

export const animationsOn = (): boolean =>
	enabled && !(typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches)

// Lo que tarda una hoja en bajar al cerrarse (en ms); después se desmonta.
export const SHEET_EXIT_MS = 240
